<template>
    <div class="d-flex flex-column justify-content-center px-1">
        <HeaderBar />
        <div class="d-flex flex-column mb-2 mt-4" style="font-size: 15px; font-weight: 500">
            <div class="add-economic-record-title1 mt-2 text-center "> Enfermedad y tratamiento (Edición)</div>
            <div class="d-flex justify-content-center headTitle">{{ fincaName }}</div>
        </div>
        <validation-observer ref="GanForm">
            <div class="mt-2">
                <b-form class="mt-2" @submit.prevent="">
                    <!-- date -->
                    <b-form-group class="datePicker flex-fill" label="Fecha">
                        <validation-provider #default="{ errors }" name="Fecha" rules="required">
                            <b-form-datepicker v-model="date" class="form-control"
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                :min="minCfgDate" :max="maxCfgDate" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <!-- vaccineName -->
                    <b-form-group label="Diagnostico" label-for="diagnosis">
                        <validation-provider #default="{ errors }" name="Diagnóstico" vid="diagnosis" rules="required">
                            <b-form-select id="diagnosis" v-model="diagnosis" :options="diagnoseOptions"
                                name="diagnosis" label="text" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <!-- averageDose -->
                    <div class="d-flex">

                        <b-form-group label="Medicamiento" label-for="medicine" class="w-50">
                            <validation-provider #default="{ errors }" name="Medicamiento" vid="medicine"
                                rules="required">
                                <b-form-input id="medicine" v-model="medicine" :state="errors.length > 0 ? false : null"
                                    name="medicine" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="Vía de Administracíon:" label-for="adminRoute" class="flex-fill ml-1">
                            <validation-provider #default="{ errors }" name="Vía de Administracíon" vid="medicine"
                                rules="required">
                                <b-form-select id="adminRoute" :options="adminRouteOptions"
                                    :values="adminRouteOptions.values" v-model="adminRoute" label="text" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </div>
                    <div class="d-flex  ">
                        <b-form-group label="Ingrediente Activo" label-for="activeIngredient" class="w-50">

                            <b-form-input id="activeIngredient" v-model="activeIngredient" />

                        </b-form-group>
                        <b-form-group label="Días de Tratamiento:" label-for="treatmentDays" class="ml-1 w-50">
                            <validation-provider #default="{ errors }" name="Días de Tratamiento" vid="medicine"
                                rules="required">
                                <b-form-input id="treatmentDays" v-model="treatmentDays" label="text" type="number" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </div>
                    <b-form-group label="Dosis " label-for="dose">
                        <validation-provider #default="{ errors }" name="Dosis" vid="dose" rules="required">
                            <b-form-input id="dose" v-model="dose" :state="errors.length > 0 ? false : null"
                                name="dose" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <div>
                        <b-form-group>
                            <!-- table -->
                            <small> ⬇ Seleccionar todos</small>
                            <vue-good-table :columns="columns" :rows="rows" :sort-options="{
                                enabled: true,
                            }" :pagination-options="{
                                enabled: true,
                                perPage: pageLength
                            }" :select-options="{
                                enabled: true,
                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                selectionInfoClass: 'custom-class',
                                selectionText: 'rows selected',
                                clearSelectionText: 'clear',
                                disableSelectInfo: true, // disable the select info panel on top
                                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                            }" @on-selected-rows-change="selectedAnimal">
                                <template slot="table-row" slot-scope="props">
                                    <!-- Column: Name -->
                                    <span v-if="props.column.field === 'sex'" class="text-center">
                                        <span v-if="props.row.sex === false" class="text-center">M</span>
                                        <span v-if="props.row.sex === true" class="text-center">H</span>
                                    </span>

                                    <!-- Column: Status -->
                                    <span v-else-if="props.column.field === 'status'">
                                        <b-badge :variant="statusVariant(props.row.status)">
                                            {{ props.row.status }}
                                        </b-badge>
                                    </span>

                                    <!-- Column: Common -->
                                    <span v-else>
                                        {{ props.formattedRow[props.column.field] }}
                                    </span>
                                </template>

                                <!-- pagination -->
                                <template slot="pagination-bottom" slot-scope="props">
                                    <div class="d-flex justify-content-between flex-wrap">
                                        <div class="d-flex align-items-center mb-0 mt-1">
                                            <span class="text-nowrap ">
                                                Mostrando 1 de
                                            </span>
                                            <b-form-select v-model="pageLength" :options="['25', '50', '100']"
                                                class="mx-1"
                                                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                                            <span class="text-nowrap"> of {{ props.total }} registros </span>
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                        </b-form-group>
                    </div>
                    <!-- submit buttons -->
                    <b-button type="submit" v-on:click="editHealthRecord"
                        class="bg-primary  mt-5 mb-5 d-flex align-items-center justify-content-center ml-3">
                        <div class="ml-5">Incluir Evento</div>
                        <div class="pl-5" style="color: #d7b92c">
                            <feather-icon icon="PlusIcon" size="18" />
                        </div>
                    </b-button>
                </b-form>
            </div>
        </validation-observer>
        <ControlMenu />
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { required } from "@validations";
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
    BButton,
    BFormSelect,
    BForm,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BFormDatepicker,
    BInputGroup,
    BFormCheckbox,
} from "bootstrap-vue";
import ControlMenu from "@/components/ControlMenu.vue";
import HeaderBar from '@/components/HeaderBar.vue'
import { VueGoodTable } from 'vue-good-table'
import axios from 'axios'

export default {
    components: {
        BButton,
        flatPickr,
        BFormCheckboxGroup,
        BForm,
        BFormSelect,
        BFormGroup,
        required,
        ControlMenu,
        HeaderBar,
        BFormInput,
        BInputGroupAppend,
        BFormDatepicker,
        BInputGroup,
        BFormCheckbox,
        ValidationProvider,
        ValidationObserver,
        vSelect,
        VueGoodTable,
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 119)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            status: "",
            date: null,
            checked: [],
            age: null,
            maxCfgDate: maxDate,
            minCfgDate: minDate,
            activeIngredient: null,
            IngredientOptions: [],
            diagnoseOptions: [],
            adminRoute: null,
            adminRouteOptions: [],
            retreatDays: null,
            dose: null,
            treatmentDays: null,
            treatmentDaysOptions: [],
            medicine: null,
            diagnosis: null,
            type_id: 4,
            ageOptions: [
                { text: "10" },
                { text: "15" },
                { text: "21" },
                { text: "30" },
                { text: "33" },
            ],
            fincaName: localStorage.getItem('currentFarmName'),
            date: null,
            animal: {
                sex: 0
            },
            animals: [],
            pageLength: 25,
            columns: [
                {
                    label: 'CODIGO',
                    field: 'number',
                },
                {
                    label: 'ANIMAL',
                    field: 'name',
                },
                {
                    label: 'SEXO',
                    field: 'sex',
                },
                {
                    label: 'PESO',
                    field: 'weight',
                },
                {
                    label: 'EDAD',
                    field: 'age',
                },
            ],
            health_record: {
                id: "",
                created_at: "",
                updated_at: "",
                product_name: "",
                diagnosis: "",
                method: "",
                result: "",
                exam_type_id: "",
                dose: "",
                reference: "",
                type_id: "",
                animal_id: "",
                date: "",
                vaccine_id: "",
                dewormer_id: "",
                dewormer_ingredient: "",
                days: "",
                farm_id: ""
            },
            rows: [],
            healths: [],
            animalsSelected: [],
            treatment: [],
        };
    },

    methods: {
        async fetchAdminRoute(config) {

            fetch(this.$apiUrl + "list/health_data_types?type=3", config)
                .then(response => response.json())
                .then(result => {
                    this.adminRouteOptions = result.health_data_types.map(item => { return { text: item.name, value: item.id } })
                })
        },

        async fetchDiagnose(config) {

            fetch(this.$apiUrl + "list/health_data_types?type=4", config)
                .then(response => response.json())
                .then(result => {
                    this.diagnoseOptions = result.health_data_types.map(item => { return { text: item.name, value: item.id } })
                })
        },

        async fetchactiveIngredient(config) {

            fetch(this.$apiUrl + "list/health_data_types?type=5", config)
                .then(response => response.json())
                .then(result => {
                    this.IngredientOptions = result.health_data_types.map(item => { return { text: item.name, value: item.id } })
                })
        },

        async fetchAnimals(config) {
            let farmId = localStorage.getItem('currentFarm');
            fetch(this.$apiUrl + "list/animals?farm_id=" + farmId + "&state=1&recperpage=all", config)
                .then(response => response.json())
                .then(result => {
                    console.log(result.animals);
                    this.rows = result.animals.map(item => { return { id: item.id, number: item.number, name: item.name, sex: item.sex, weight: item.weight, age: item.age } });
                    console.log(this.animals);
                })
        },

        async selectedAnimal(params) {
            console.log(params.selectedRows);
            this.treatment = params.selectedRows.map(item => { return { animal_id: item.id, diagnosis: this.diagnosis, product_name: this.medicine, dewormer_ingredient: this.activeIngredient, date: this.date, type_id: this.type_id, days: this.treatmentDays, dose: this.dose, method: this.adminRoute, farm_id: localStorage.getItem('currentFarm') } })
        },


        editHealthRecord() {
            console.log("1entra");
            this.$refs.GanForm.validate().then(success => {
                if (success) {
                    let id = parseInt(this.$route.params.id);
                    let self = this;

                    const token = localStorage.getItem("accessToken");
                    const config = { headers: { "X-Authorization": `Bearer ${token}` } };
                    console.log("items", id)
                    var request = this.treatment.map(items => this.$http.post("edit/health_records/" + id, items, config));
                    console.log("items2", this.treatment)
                    axios.all(request)
                        .then(() => {
                            this.$swal({
                                title: 'Edición de Tratamiento',
                                text: 'Se Editaron los registros de Tratamiento de manera satisfactoria',
                                type: 'success',
                                icon: 'success',
                                showCancelButton: false,
                                confirmButtonColor: '#5E8F23',
                                showCloseButton: true,
                                showLoaderOnConfirm: false
                            }).then(function () {
                                history.back();
                            });
                        });
                }
            })

        },

        async fetchhealth_recordData(config) {
            console.log('entra');
            let id = parseInt(this.$route.params.id);
            console.log('entra', id);
            fetch(this.$apiUrl + "view/health_records/" + id, config)
                .then(response => response.json())
                .then(result => {
                    console.log("res", result.health_records)

                    this.date = result.health_records.date;
                    this.medicine = result.health_records.product_name;
                    this.activeIngredient = result.health_records.dewormer_ingredient;
                    this.treatmentDays = result.health_records.days;
                    this.dose = result.health_records.dose;

                })
        }


    },

    created() {
        const token = localStorage.getItem("accessToken");
        const config = { headers: { "X-Authorization": `Bearer ${token}` } };

        this.fetchAdminRoute(config);
        this.fetchactiveIngredient(config);

        this.fetchAnimals(config);
        this.fetchDiagnose(config);
        this.fetchhealth_recordData(config);
    }
};
</script>

<style lang="scss">
.titleTreatment {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5e5873;
}

.headTitle {
    font-weight: 600;
    font-size: 24px;
    color: #5E8F23;
}

@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>